import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';
import { Component } from 'vue';
import { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

/**
 * タブ切り替え時のルーター情報
 */
export interface ForecastForReceiptRouterInfo extends IRouterInfo {
  component: Component;
}

/**
 * ルーター情報とルート情報が一致するか
 * @param route - ルート情報
 * @param info - 用意したルーター情報
 */
export const isEqualRouterInfo = (route: RouteLocationNormalizedLoadedGeneric, info: IRouterInfo): boolean => {
  return route.path === info.router || (info.name !== undefined && route.name === info.name);
};
